const translations = {
  tr: {
    nav: {
      home: "Ana Sayfa",
      about: "Hakkımda",
      services: "Hizmetler",
      diseases: "Hastalıklar",
      diagnostics: "Tanı ve Testler",
      home_health: "Evde Sağlık",
      lifestyle: "Yaşam Önerileri",
      contact: "İletişim",
    },
    hero: {
      overline: "Dahiliye Uzmanı",
      title: "Dr. Burcu Varol",
      subtitle:
        "Sağlığınız ve güzelliğiniz için profesyonel, güvenilir ve kişiye özel tedavi yaklaşımı. İnsana bütünsel olarak bakmak çok değerli ve önemlidir.",
      cta: "Randevu Alın",
      secondary_cta: "Daha Fazla Bilgi",
    },
    about: {
      overline: "Hakkımda",
      title: "Dr. Burcu Varol Kimdir?",
      bio_p1:
        "Dr. Burcu Varol, dahiliye alanında uzman ve deneyimli bir hekimdir. Hastalarına en yüksek kalitede sağlık hizmeti sunmayı hedeflemektedir. Tıp fakültesinden mezun olduktan sonra uzmanlık eğitimini başarıyla tamamlamış ve kariyerine devam etmektedir.",
      bio_p2:
        "Hastalarının sağlık ve yaşam kalitesini artırmak için en güncel tedavi yöntemlerini uygulayan Dr. Varol, kişiye özel tedavi planları ile tanınmaktadır. Her hastasına bireysel yaklaşımı ve empatik tutumu ile güven vermektedir.",
      bio_p3:
        "Ulusal ve uluslararası kongrelere katılım sağlayan Dr. Varol, sürekli mesleki gelişim ilkesiyle çalışmaktadır. İnsan hasta olduğunda sadece hasta olan doku ya da organa odaklanmak arkadaki düzeni kaçırmaya sebep olabilir. İşte tam da bu yüzden dahiliye sebep sonuç ilişkisini aydınlatmada diğer faktörlere de bakarak sorunu temelden tanımaya odaklanır.",
      stats: {
        experience: "15+ Yıl",
        experience_label: "Deneyim",
        patients: "10.000+",
        patients_label: "Mutlu Hasta",
        certifications: "20+",
        certifications_label: "Sertifika",
      },
    },
    why_visit: {
      title: "Dahiliye Doktoruna Neden Gidilir?",
      reasons: [
        "Uzun süredir yorgunluk kırgınlık hissediyorsanız",
        "Tahlillerinizi hiç yaptırmadıysanız",
        "Şeker, kolesterol, tansiyon, kalp, tiroid, kortizol seviyelerinizi merak ediyorsanız",
        "Karaciğer, böbrek, safra kesesi, dalak organlarınızın durumunu merak ediyorsanız",
        "Saçlarınız dökülüyorsa veya uyku sorununuz varsa",
        "Kilo kaybediyor veya alıyorsanız",
        "Nefes darlığı, öksürük gibi şikayetleriniz varsa",
        "Karın ağrısı, bulantı, kusma şikayetleriniz varsa",
        "Çarpıntı, göğüs ağrısı yaşıyorsanız",
        "Boyun ağrısı, tiroid sorunlarınız varsa",
        "El ve ayaklarda uyuşma, karıncalanma varsa",
        "Ailenizde diyabet, tansiyon, kolesterol hastalıkları varsa",
      ],
      footer: "Yolunuz bir kere de olsa dahiliye doktoru ile kesişmelidir.",
    },
    services: {
      overline: "Hizmetlerimiz",
      title: "Tedavi Alanları",
      subtitle:
        "Geniş tedavi yelpazesi ile sağlığınız için en uygun çözümleri sunuyoruz.",
      categories: [
        {
          title: "Hastalıklar ve Koşullar",
          description: "Şeker hastalığı, hipertansiyon, kolesterol, tiroid, sindirim sistemi, böbrek, solunum sistemi ve enfeksiyon hastalıkları.",
          icon: "Stethoscope",
          link: "/services#diseases",
        },
        {
          title: "Tanı ve Testler",
          description: "Kan testleri, görüntüleme yöntemleri, endoskopi, kolonoskopi, solunum fonksiyon testleri.",
          icon: "FlaskConical",
          link: "/services#diagnostics",
        },
        {
          title: "Tedavi Yöntemleri",
          description: "İlaç tedavisi, yaşam tarzı değişiklikleri, diyet ve beslenme, kronik hastalık yönetimi.",
          icon: "Heart",
          link: "/services#treatments",
        },
        {
          title: "Evde Sağlık Hizmeti",
          description: "Sağlık profesyonellerinin hastaların kendi evlerinde sağlık hizmeti sunması.",
          icon: "Home",
          link: "/home-health",
        },
        {
          title: "Yaşam Tarzı Değişiklikleri",
          description: "Sağlık koçluğu, kadın sağlığı, beslenme danışmanlığı, egzersiz tavsiyeleri.",
          icon: "Sparkles",
          link: "/lifestyle",
        },
        {
          title: "Önleme ve Check-Up",
          description: "Sağlık tarama programları, check-up, koruyucu sağlık hizmetleri, aşılar.",
          icon: "ShieldCheck",
          link: "/services#prevention",
        },
      ],
    },
    diseases: {
      title: "Hastalıklar ve Koşullar",
      items: [
        {
          title: "Diyabet (Şeker Hastalığı)",
          content: "Ağız kuruluğu, çok su içme, çok sık idrara çıkma, ilk dönemde kilo artışı, aşırı iştah sonraki dönemlerde kilo kaybı kas kaybı ile giden bir hastalıktır. Tip 2 diyabet tanısı alan kişiler genelde hamur işine düşkün ve/veya tatlı yeme isteği çok duyan, atıştırma ve keyif için yemek yemeye yatkın, stresli ve yüksek tempoda çalışan, yemeklerle duygusal rahatlama sağlayan grupta sıklıkla görülür. Diyabet hastalığının çoğunun sebebi değiştirilebilir faktörlerdir. Tip 2 Diyabet kalıtsal aktarılsa da beslenme ile kontrolü sağlanabilir. Diyabet en az 8 saat açlık sonrası sabah 08-10:00 arası alınan venöz kanda ölçümün 125 mg/dl üstünde çıkmasıdır.",
        },
        {
          title: "Hipertansiyon (Yüksek Tansiyon)",
          content: "Başlıca şikayetler; baş ağrısı, ense ağrısı, baş dönmesi, kulak çınlaması, ense ve omuzlarda ağırlık, şakaklarda ağrı şeklinde kendini gösterir. Kan basıncının normalden yüksek seyretmesi durumudur. Hipertansiyon tüm vücudu ilgilendirmekle beraber temelde damar ve kalp sisteminize dikkat çeker. Toplumumuzda hipertansif hastaların çoğunun kolesterolü yüksektir. Hipertansiyon >140/90 mm Hg olarak tanı alır. Tek ölçümden ziyade 10 günlük takip değerlendirmesi önerilir. Takibi ve tedavisi önemlidir.",
        },
        {
          title: "Kolesterol Problemleri",
          content: "Kolesterol yüksekliğinin çeşitli sebepleri olmakla birlikte beslenme ve yaşam değişikliği ile önemli derecede kontrol altına alınır. Kalıtsal yatkınlık, ayçiçek yağı, margarin, palm yağı gibi yağların mutfakta bulundurulması, çok sık dışarıda yemek yemek, alkol kullanımı, aburcubur tüketimi, hareketsizlik bu durumu tetikler. Beslenmede yağ seçimi önem taşır: zeytinyağı, avokado yağı, omega 3'ten zengin yağlara ağırlık vermek gerekir.",
        },
        {
          title: "Tiroid Hastalıkları",
          content: "Boynun ile gövdenin birleştiği ön alanda bulunan bir bez olarak tanımladığımız organdır. Metabolizmanın çalışma hızında görevlidir. Gün içinde iş yapabilme kabiliyetiniz, hareketlerinizdeki hızlanma ve yavaşlama, uykunuz, iştahınız, barsaklarınızın çalışma hızı, kilonuz, cilt ve saç sağlığınız, terleme durumunuz, ruh haliniz tiroid metabolizmanızla ilgilidir. Günlük pratiğimde en sık karşılaştığım Hashimoto tiroidit hastalığıdır. Ultrason sonuçları ile takibine devam ederim. Tiroid nodülü takip sonrası gereklilik halinde biyopsiden kaçmamalıdır.",
        },
        {
          title: "Sindirim Sistemi Hastalıkları",
          content: "Ağızdan başlayıp anüs ile biten yol üzerindeki organlarla beraber karaciğer, safra kesesi, pankreası içerir. Reflü, özofajit, gastrit, ülser, safra kesesi taşı, pankreatit gibi hastalıkların tanı ve tedavisini kliniğimizde gerçekleştirmekteyiz. Midede gastrit ülser gibi hastalıklar meydana gelir. Karaciğer hücrelerinin iltihabı olan hepatit, safra kesesi taşı ve iltihabı olan kolesistit, pankreas iltihabı olan pankreatit tanı ve tedavileri kliniğimizde yapılmaktadır.",
        },
        {
          title: "Böbrek Hastalıkları",
          content: "Böbrek toksinleri uzaklaştıran, bunu idrar oluşturarak yapan bir organdır. Kanı filtreleyen bir organdır. Bu yolla vücudun asit-baz, su ve elektrolit dengesi sağlanır. Başlıca hastalıkları: Akut böbrek yetersizliği, kronik böbrek yetersizliği, nefritler, damar hastalıkları (renal arter stenozu), böbrek taşı. Az su içme, enfeksiyon, asidik içecekler, kireçli sulara bağlı taş, çamur, kum, kristal böbrekte ve idrar yollarında oluşabilir.",
        },
        {
          title: "Solunum Sistemi Hastalıkları",
          content: "Solunum sistemi burun, farenksi, larenks, bronşlar, bronşioller ve akciğer organlarını kapsar. KOAH, astım, zatürre, sarkoidoz, tüberküloz, akciğer zarında sıvı toplanması gibi hastalıkların tanı ve tedavisini yapmaktayız. KOAH kronik obstrüktif akciğer hastalığıdır. En sık sebebi sigaradır. Astım bronşlarda olan spazm halidir. Solunum fonksiyon testi eşliğinde tanı ve değerlendirmesini yapmaktayız.",
        },
        {
          title: "Enfeksiyon Hastalıkları",
          content: "Sinüzit, otit, faranjit, bronşit, tonsillit, zatürre, sellülit, gastroenterit, kolit, idrar yolları enfeksiyonu, sistit gibi enfeksiyonların tedavisi. Genital enfeksiyonlar, cilt enfeksiyonları, mantar enfeksiyonları tanı ve tedavisi kliniğimizde yapılmaktadır.",
        },
      ],
    },
    diagnostics: {
      title: "Tanı ve Testler",
      items: [
        {
          title: "Kan Testleri",
          content: "Tam Kan (Hemogram), Biyokimya (kan şeker düzeyi, üç aylık şeker profili, kolesterol tahlilleri, karaciğer tahlilleri, böbrek testleri, tuz iyon dengesi), Hormon tahlilleri (insülin direnci, tiroid hormonları, menopozal hormonlar, stres hormonları), Romatolojik markerlar, Tümör markerları, İdrar tahlili, Dışkı değerlendirmesi, Üre nefes testi ile midede mikrop taraması.",
        },
        {
          title: "Radyolojik Görüntüleme",
          content: "X-Ray Röntgen (en sık akciğer), Ultrason (karın, tiroid, safra kesesi, böbrek), Doppler ultrason (boyun damarları, karaciğer portal alan, bacak damarları), Bilgisayarlı Tomografi (kemik, taş, akciğer), Magnetik Rezonans (yumuşak doku, tümöral yapı, MRCP, MR anjiyo). Kliniğimizde gereklilik halinde tüm görüntüleme yöntemleri planlanmaktadır.",
        },
        {
          title: "Endoskopi ve Kolonoskopi",
          content: "Endoskopi: Mide yemek borusu şikayetlerinde ağızdan bir boru ve kamera yardımıyla organı görüntülemede faydalandığımız bir yöntemdir. Gastrit, ülser, Helicobacter pylori tespiti yapılır. Kolonoskopi: Anüsten girerek kalın barsak görüntüleme işlemidir. 50 yaşından sonra mutlaka 1 kez yaptırılmalıdır. Ailede öykü varsa bu yaş 40'a iner.",
        },
        {
          title: "Solunum Fonksiyon Testleri",
          content: "Bir cihazla soluk alıp direktiflere uygun nefes tutarak ve nefes verilerek yapılan kolay ve yararlı bir testtir. KOAH, astım, bronşit gibi hastalıkların tanı ve değerlendirmesinde kullanılır. Bu testi kliniğimizde yorumlayıp gerekli yaklaşımı uygulamaktayız.",
        },
      ],
    },
    treatments: {
      title: "Tedavilerimiz",
      items: [
        "NAD, Myers Kokteyli, antioksidan tedaviler, vitamin tedavileri",
        "Demir tedavisi",
        "Diyabet hap ve insülin tedavileri",
        "Tiroid tedavileri",
        "Hipertansiyon ve kalp hastalıkları tedavileri",
        "Kalp Yetmezliği tedavisi",
        "Kolesterol tedavisi",
        "Menopoz ve kemik erimesi takip ve tedavisi",
        "Fonksiyonel Tıp Uygulamaları",
        "Halsizlik yorgunluk tedavileri",
        "Reflü, gastrit, ülser, hepatit, siroz tedavileri",
        "Helicobacter pylori mide mikrobu tedavisi",
        "İshal tedavisi ve irritabl barsak hastalığı tedavisi",
        "Kronik böbrek hastalığı takibi",
        "Böbrek taşı-kumu tedavisi",
        "Yaşlı ve çoklu ilaç kullanımı olan hasta takibi",
        "Romatolojik hastalıkların tanı ve takibi",
        "Enfeksiyon hastalıkları tedavisi",
        "Diyabetik yara tedavisi",
        "Parazit tanı ve tedavisi",
        "Saçlı deri, egzama ve cilt tedavileri",
        "Hemoroid, varis, damar hastalıkları tanı ve tedavisi",
      ],
    },
    prevention: {
      title: "Önleme ve Check-Up",
      description: "Sağlık taramasında en sık yaygın olan Check-Up yöntemimizle genel sağlık kontrollerinizi hızlı ve etkin yapıyoruz. Check-up programımızda çeşitli kan tahlilleri, görüntüleme çalışmaları ve yaşamınızın sonraki dönemindeki risk faktörleriniz kısa sürede değerlendirilmekte; yol haritası çıkarılmaktadır. Kadınlarda menopoz ve kemik erimesi testleri, erkeklerde prostat testleri eklenmektedir.",
      healthy_life_title: "İyi Bir Yaşam İçin",
      healthy_life_intro: "Sağlığın tanımı; bedenen, ruhen ve sosyal yönden tam bir iyi olma halidir.",
      healthy_life_items: [
        "Her gün vücudumuza giren havanın temiz olması",
        "Bünyemize aldığımız gıdaların sağlıklı olması",
        "İhtiyaç duyduğumuz iyi uykunun karşılanması",
        "Toksik maddelerden kaçınılması",
        "Yeterli ve iyi su içmek",
        "Bedenimizi egzersizle temas halinde tutmak",
        "Özbakımı artırma çalışmaları",
        "Ruh sağlığımız için gerekli sosyal, ailevi ilişkilerin desteklenmesi",
      ],
    },
    home_health: {
      overline: "Evde Sağlık Hizmeti",
      title: "Evde Sağlık Hizmeti",
      intro: "Evde sağlık hizmeti, sağlık profesyonellerinin hastaların kendi evlerinde sağlık hizmeti sunmasıdır. Bu hizmetler genellikle hastaneye gitmeye vakti olmayan sık seyahat eden genç orta yaşlı popülasyonda olduğu gibi hareket kabiliyeti kısıtlı, yaşlı veya kronik hastalıkları bulunan bireyler için de sunulur.",
      services: [
        { title: "Hemşirelik Bakımı", description: "Yara bakımı, enjeksiyon, ilaç yönetimi ve genel sağlık takipleri." },
        { title: "Doktor Ziyaretleri", description: "Belirli aralıklarla doktorların hastaların evlerine gelip muayene yapması ve tedavi planlaması, uygulaması." },
        { title: "Evde Laboratuvar Testleri", description: "Kan testi gibi bazı laboratuvar testlerinin evde yapılabilmesi." },
        { title: "Beslenme Danışmanlığı", description: "Beslenme rehberliği ve destek." },
        { title: "Serum Tedavileri", description: "Bağışıklık kazandırıcı serumlar, vitamin takviyesi içeren serumlar." },
      ],
      benefits: "Evde sağlık hizmetleri, hastaların konforunu artırabilir, hastaneye gitme stresini azaltabilir ve sağlık yönetimini daha kişiselleştirilmiş bir hale getirebilir.",
      cta: "Eğer bu tür bir hizmeti düşünüyorsanız Dr. Burcu Varol kliniği ile iletişime geçebilirsiniz.",
    },
    lifestyle: {
      overline: "Yaşam Önerileri",
      title: "Yaşam Tarzınızı İyileştirin",
      intro: "Yaşam tarzınızı iyileştirmek için size bazı öneriler sunacağım.",
      tips: [
        { title: "Düzenli Egzersiz Yapın", description: "Haftada en az 150 dakika orta yoğunlukta fiziksel aktivite yapmanız sağlığınız için önemli." },
        { title: "Sağlıklı Beslenin", description: "İşlenmiş gıdalardan kaçının, sebze, meyve, tam tahıllı ürünler ve yağsız protein kaynaklarına yönelin." },
        { title: "Yeterli Uyku Alın", description: "Yetişkinler için önerilen uyku süresi 7-9 saat arasındadır. Düzenli uyku rutini oluşturun." },
        { title: "Stresle Başa Çıkın", description: "Meditasyon, yoga, nefes egzersizleri gibi yöntemler kullanın." },
        { title: "Sosyal Bağlantılarınızı Güçlendirin", description: "İnsanlarla kurulan güçlü ilişkiler kişisel ve profesyonel yaşamda fayda sağlar. Sosyal bağlantılar ruh sağlığı ve genel refah üzerinde olumlu etki yapar." },
        { title: "Sağlık Kontrollerinizi Aksatmayın", description: "Düzenli sağlık kontrolleri ile erken teşhis ve önlem almak çok önemli." },
      ],
      lifestyle_services: [
        "Sağlık Koçluğu",
        "Kadın Sağlığı",
        "Menopoz Beslenmesi ve Egzersizi",
        "Kemik Erimesi, Osteoporoz için Alışkanlıklar Geliştirme",
        "Yaşa Göre Bireyselleştirilmiş Sağlıklı Dengeli Beslenme",
        "40 Yaş Sonrası Egzersiz Tavsiyeleri",
        "Yürüyüş Şekli Önerileri",
        "Uyku Sağlığı",
        "Nefes Çalışmaları",
        "Access the Bars Uygulamaları",
      ],
    },
    contact: {
      overline: "İletişim",
      title: "Bizimle İletişime Geçin",
      subtitle:
        "Sorularınız veya randevu talepleriniz için formu doldurun, en kısa sürede size dönüş yapalım.",
      form: {
        name: "Adınız Soyadınız",
        email: "E-posta Adresiniz",
        phone: "Telefon Numaranız",
        subject: "Konu",
        message: "Mesajınız",
        submit: "Mesaj Gönder",
        sending: "Gönderiliyor...",
        success: "Mesajınız başarıyla gönderildi!",
        error: "Bir hata oluştu. Lütfen tekrar deneyin.",
      },
      info: {
        address_label: "Adres",
        address: "İstanbul, Türkiye",
        phone_label: "Telefon",
        phone: "+90 (212) 555 00 00",
        email_label: "E-posta",
        email: "info@drburcuvarol.com",
        hours_label: "Çalışma Saatleri",
        hours: "Pzt - Cum: 09:00 - 18:00\nCmt: 09:00 - 14:00",
      },
      appointment: {
        title: "Randevu",
        online: "Online ve yüz yüze randevu",
        payment: "Havale / IBAN / Kredi kartı",
      },
    },
    footer: {
      description:
        "Dr. Burcu Varol — Sağlığınız için profesyonel, güvenilir ve kişiye özel tedavi yaklaşımı.",
      quick_links: "Hızlı Bağlantılar",
      contact_info: "İletişim Bilgileri",
      rights: "Tüm hakları saklıdır.",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      diseases: "Diseases",
      diagnostics: "Diagnostics",
      home_health: "Home Health",
      lifestyle: "Lifestyle Tips",
      contact: "Contact",
    },
    hero: {
      overline: "Internal Medicine Specialist",
      title: "Dr. Burcu Varol",
      subtitle:
        "Professional, reliable, and personalized treatment approach for your health. A holistic approach to human health is invaluable and essential.",
      cta: "Book Appointment",
      secondary_cta: "Learn More",
    },
    about: {
      overline: "About",
      title: "Who is Dr. Burcu Varol?",
      bio_p1:
        "Dr. Burcu Varol is an expert and experienced physician specializing in internal medicine. She aims to provide the highest quality healthcare to her patients. After graduating from medical school, she successfully completed her specialization training and continues her career.",
      bio_p2:
        "Dr. Varol, who applies the most up-to-date treatment methods to improve the health and quality of life of her patients, is known for her personalized treatment plans. She inspires confidence with her individual approach and empathetic attitude towards every patient.",
      bio_p3:
        "Dr. Varol, who participates in national and international congresses, works with the principle of continuous professional development. When a person is ill, focusing solely on the affected tissue or organ can lead to missing the underlying system. That is exactly why internal medicine focuses on understanding the problem from its root by examining other factors in illuminating cause-effect relationships.",
      stats: {
        experience: "15+ Years",
        experience_label: "Experience",
        patients: "10,000+",
        patients_label: "Happy Patients",
        certifications: "20+",
        certifications_label: "Certifications",
      },
    },
    why_visit: {
      title: "Why Visit an Internal Medicine Doctor?",
      reasons: [
        "If you have been feeling fatigued and weak for a long time",
        "If you have never had your tests done",
        "If you are curious about your blood sugar, cholesterol, blood pressure, heart, thyroid, cortisol levels",
        "If you are curious about the condition of your liver, kidneys, gallbladder, spleen",
        "If your hair is falling out or you have sleep problems",
        "If you are losing or gaining weight",
        "If you have complaints such as shortness of breath or cough",
        "If you have abdominal pain, nausea, vomiting",
        "If you experience palpitations or chest pain",
        "If you have neck pain or thyroid problems",
        "If you have numbness or tingling in hands and feet",
        "If there is a family history of diabetes, hypertension, or cholesterol disorders",
      ],
      footer: "Your path should cross with an internal medicine doctor at least once.",
    },
    services: {
      overline: "Our Services",
      title: "Treatment Areas",
      subtitle:
        "We offer the most suitable solutions for your health with a wide range of treatments.",
      categories: [
        {
          title: "Diseases & Conditions",
          description: "Diabetes, hypertension, cholesterol, thyroid, digestive system, kidney, respiratory system, and infectious diseases.",
          icon: "Stethoscope",
          link: "/services#diseases",
        },
        {
          title: "Diagnosis & Tests",
          description: "Blood tests, imaging methods, endoscopy, colonoscopy, pulmonary function tests.",
          icon: "FlaskConical",
          link: "/services#diagnostics",
        },
        {
          title: "Treatment Methods",
          description: "Medication therapy, lifestyle changes, diet and nutrition, chronic disease management.",
          icon: "Heart",
          link: "/services#treatments",
        },
        {
          title: "Home Health Service",
          description: "Health professionals providing healthcare services at patients' own homes.",
          icon: "Home",
          link: "/home-health",
        },
        {
          title: "Lifestyle Changes",
          description: "Health coaching, women's health, nutrition counseling, exercise recommendations.",
          icon: "Sparkles",
          link: "/lifestyle",
        },
        {
          title: "Prevention & Check-Up",
          description: "Health screening programs, check-ups, preventive health services, vaccinations.",
          icon: "ShieldCheck",
          link: "/services#prevention",
        },
      ],
    },
    diseases: {
      title: "Diseases & Conditions",
      items: [
        {
          title: "Diabetes (Type 2)",
          content: "Dry mouth, excessive thirst, frequent urination, weight gain in the early period, excessive appetite, and weight loss with muscle loss in later periods. People diagnosed with Type 2 diabetes are often fond of pastries and/or have strong cravings for sweets, are prone to snacking, work under stress and at a high pace, and seek emotional comfort through food. Most causes of diabetes are modifiable factors. Type 2 Diabetes can be controlled through nutrition even if genetically transmitted.",
        },
        {
          title: "Hypertension (High Blood Pressure)",
          content: "Main symptoms include headache, neck pain, dizziness, tinnitus, heaviness in the shoulders, and temple pain. Hypertension is diagnosed at >140/90 mm Hg. A 10-day monitoring evaluation is recommended rather than a single measurement. Follow-up and treatment are important. Hypertension affects the whole body but primarily draws attention to your vascular and cardiac system.",
        },
        {
          title: "Cholesterol Problems",
          content: "Although cholesterol elevation has various causes, it can be significantly controlled with nutrition and lifestyle changes. Genetic predisposition, using sunflower oil, margarine, palm oil in cooking, eating out frequently, alcohol use, junk food consumption, and inactivity trigger this condition. In nutrition, choosing olive oil, avocado oil, and omega-3 rich oils is important.",
        },
        {
          title: "Thyroid Diseases",
          content: "An organ defined as a gland located in the front area where the neck meets the body. It is responsible for the speed of metabolism. Your ability to work during the day, speed of movements, sleep, appetite, bowel function speed, weight, skin and hair health, sweating, and mood are all related to your thyroid metabolism. The most common condition I encounter is Hashimoto's thyroiditis. Thyroid nodules should not avoid biopsy when necessary after follow-up.",
        },
        {
          title: "Digestive System Diseases",
          content: "Includes organs along the path from mouth to anus, along with the liver, gallbladder, and pancreas. We perform diagnosis and treatment of diseases such as reflux, esophagitis, gastritis, ulcer, gallbladder stones, pancreatitis at our clinic. Hepatitis, cholecystitis, pancreatitis diagnosis and treatments are all carried out at our clinic.",
        },
        {
          title: "Kidney Diseases",
          content: "The kidney is an organ that removes toxins by producing urine and filtering blood. Through this process, the body's acid-base, water, and electrolyte balance is maintained. Main diseases include: acute kidney failure, chronic kidney failure, nephritis, vascular diseases, kidney stones. Stones, sand, and crystals can form in kidneys and urinary tract due to insufficient water intake, infection, acidic beverages.",
        },
        {
          title: "Respiratory System Diseases",
          content: "The respiratory system includes the nose, pharynx, larynx, bronchi, bronchioles, and lungs. We diagnose and treat diseases such as COPD, asthma, pneumonia, sarcoidosis, tuberculosis, and pleural effusion. COPD is a chronic obstructive pulmonary disease with smoking as the most common cause. Asthma is a bronchial spasm condition. Diagnosis and assessment are conducted with pulmonary function tests.",
        },
        {
          title: "Infectious Diseases",
          content: "Treatment of infections such as sinusitis, otitis, pharyngitis, bronchitis, tonsillitis, pneumonia, cellulitis, gastroenteritis, colitis, urinary tract infections, and cystitis. Genital infections, skin infections, and fungal infections are diagnosed and treated at our clinic.",
        },
      ],
    },
    diagnostics: {
      title: "Diagnosis & Tests",
      items: [
        {
          title: "Blood Tests",
          content: "Complete Blood Count (Hemogram), Biochemistry (blood sugar, 3-month sugar profile, cholesterol, liver tests, kidney tests, electrolyte balance), Hormone tests (insulin resistance, thyroid hormones, menopausal hormones, stress hormones), Rheumatological markers, Tumor markers, Urinalysis, Stool evaluation, Urea breath test for gastric microbe screening.",
        },
        {
          title: "Radiological Imaging",
          content: "X-Ray (most commonly chest), Ultrasound (abdomen, thyroid, gallbladder, kidney), Doppler ultrasound (neck vessels, liver portal area, leg vessels), CT scan (bone, stones, lungs), MRI (soft tissue, tumoral structures, MRCP, MR angiography). All imaging methods are planned as needed at our clinic.",
        },
        {
          title: "Endoscopy & Colonoscopy",
          content: "Endoscopy: A method using a tube and camera through the mouth to view the stomach and esophagus. Gastritis, ulcer, and Helicobacter pylori detection are performed. Colonoscopy: Large bowel imaging from the anus. Must be performed at least once after age 50. This drops to 40 if there's a family history.",
        },
        {
          title: "Pulmonary Function Tests",
          content: "An easy and useful test performed by breathing into a device following instructions. Used for diagnosis and evaluation of COPD, asthma, bronchitis. We interpret this test and implement the necessary approach at our clinic.",
        },
      ],
    },
    treatments: {
      title: "Our Treatments",
      items: [
        "NAD, Myers Cocktail, antioxidant therapies, vitamin treatments",
        "Iron therapy",
        "Diabetes medication and insulin treatments",
        "Thyroid treatments",
        "Hypertension and cardiac disease treatments",
        "Heart failure treatment",
        "Cholesterol treatment",
        "Menopause and osteoporosis follow-up and treatment",
        "Functional Medicine Applications",
        "Fatigue and exhaustion treatments",
        "Reflux, gastritis, ulcer, hepatitis, cirrhosis treatments",
        "Helicobacter pylori treatment",
        "Diarrhea and irritable bowel syndrome treatment",
        "Chronic kidney disease follow-up",
        "Kidney stone treatment",
        "Elderly and multi-medication patient follow-up",
        "Rheumatological disease diagnosis and follow-up",
        "Infectious disease treatments",
        "Diabetic wound treatment",
        "Parasite diagnosis and treatment",
        "Scalp, eczema and skin treatments",
        "Hemorrhoid, varicose vein, vascular disease diagnosis and treatment",
      ],
    },
    prevention: {
      title: "Prevention & Check-Up",
      description: "We perform your general health check-ups quickly and effectively with our most common Check-Up method. In our check-up program, various blood tests, imaging studies, and risk factors for the next period of your life are evaluated in a short time; a roadmap is created. Menopause and osteoporosis tests are added for women, prostate tests for men.",
      healthy_life_title: "For a Good Life",
      healthy_life_intro: "The definition of health is a state of complete physical, mental, and social well-being.",
      healthy_life_items: [
        "Clean air entering our body every day",
        "Healthy foods that we consume",
        "Meeting our need for good sleep",
        "Avoiding toxic substances",
        "Drinking sufficient and quality water",
        "Keeping our body in contact with exercise",
        "Self-care improvement activities",
        "Supporting social and family relationships for mental health",
      ],
    },
    home_health: {
      overline: "Home Health Service",
      title: "Home Health Service",
      intro: "Home health service is the provision of healthcare by health professionals at patients' own homes. These services are offered for individuals with limited mobility, elderly, or those with chronic diseases, as well as for young and middle-aged populations who travel frequently and don't have time to go to the hospital.",
      services: [
        { title: "Nursing Care", description: "Wound care, injections, medication management, and general health monitoring." },
        { title: "Doctor Visits", description: "Doctors visiting patients' homes at certain intervals for examination, treatment planning, and implementation." },
        { title: "Home Laboratory Tests", description: "Ability to perform some laboratory tests such as blood tests at home." },
        { title: "Nutrition Counseling", description: "Nutritional guidance and support." },
        { title: "IV Therapy", description: "Immune-boosting serums, vitamin supplement serums." },
      ],
      benefits: "Home health services can increase patient comfort, reduce the stress of hospital visits, and make health management more personalized.",
      cta: "If you are considering such a service, you can contact Dr. Burcu Varol's clinic.",
    },
    lifestyle: {
      overline: "Lifestyle Tips",
      title: "Improve Your Lifestyle",
      intro: "I will offer you some suggestions to improve your lifestyle.",
      tips: [
        { title: "Exercise Regularly", description: "At least 150 minutes of moderate-intensity physical activity per week is important for your health." },
        { title: "Eat Healthy", description: "Avoid processed foods, opt for vegetables, fruits, whole grains, and lean protein sources." },
        { title: "Get Enough Sleep", description: "The recommended sleep duration for adults is 7-9 hours. Establish a regular sleep routine." },
        { title: "Manage Stress", description: "Use methods such as meditation, yoga, and breathing exercises." },
        { title: "Strengthen Social Connections", description: "Strong relationships with people benefit personal and professional life. Social connections have positive effects on mental health and overall well-being." },
        { title: "Don't Skip Health Check-ups", description: "Early diagnosis and prevention through regular health check-ups is very important." },
      ],
      lifestyle_services: [
        "Health Coaching",
        "Women's Health",
        "Menopause Nutrition and Exercise",
        "Developing Habits for Osteoporosis",
        "Age-Personalized Healthy Balanced Nutrition",
        "Exercise Recommendations After 40",
        "Walking Style Recommendations",
        "Sleep Health",
        "Breathing Exercises",
        "Access the Bars Applications",
      ],
    },
    contact: {
      overline: "Contact",
      title: "Get in Touch",
      subtitle:
        "Fill out the form for your questions or appointment requests, and we will get back to you as soon as possible.",
      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        subject: "Subject",
        message: "Your Message",
        submit: "Send Message",
        sending: "Sending...",
        success: "Your message has been sent successfully!",
        error: "An error occurred. Please try again.",
      },
      info: {
        address_label: "Address",
        address: "Istanbul, Turkey",
        phone_label: "Phone",
        phone: "+90 (212) 555 00 00",
        email_label: "Email",
        email: "info@drburcuvarol.com",
        hours_label: "Working Hours",
        hours: "Mon - Fri: 09:00 - 18:00\nSat: 09:00 - 14:00",
      },
      appointment: {
        title: "Appointment",
        online: "Online and face-to-face appointments",
        payment: "Bank Transfer / IBAN / Credit Card",
      },
    },
    footer: {
      description:
        "Dr. Burcu Varol — Professional, reliable, and personalized treatment approach for your health.",
      quick_links: "Quick Links",
      contact_info: "Contact Info",
      rights: "All rights reserved.",
    },
  },
};

export default translations;
